'use strict';

/**
 * iPad - Custom Modernizr Test
 *
 * If the device is an ios device, the class "ios" will be added to <html>.
 *
 * @author Jan Widmer <jan.widmer@namics.com>
 */
Modernizr.addTest('ios', function () {
  return (/iPad|iPhone|iPod/g.test(navigator.userAgent)
  );
});